const getVideoProviderFromEmbed = (embed: any) => {
  if (embed.includes('player.vimeo')) {
    return 'vimeo';
  }

  return 'youtube';
};

export default getVideoProviderFromEmbed;
